const accountPermissions = {
    view: ['view.account'],
    create: [
        'create.flexControl',
        'create.location',
        'create.phoneNumber',
    ] as string[],
    edit: [
        'edit.accountStatus',
        'edit.customer',
        'edit.dueDate',
        'edit.limits',
        'edit.location',
        'edit.phoneNumber',
    ] as string[],
    delete: ['delete.location'] as string[],
};

const cardPermissions = {
    view: ['view.cardsList'],
    create: [] as string[],
    edit: [] as string[],
    delete: [] as string[],
};

const SCOPES = {
    canView: [...accountPermissions.view, ...cardPermissions.view],
    canCreate: [...accountPermissions.create, ...cardPermissions.create],
    canEdit: [...accountPermissions.edit, ...cardPermissions.edit],
    canDelete: [...accountPermissions.delete, ...cardPermissions.delete],
};

export const PERMISSIONS_MAP = {
    readonly: [...SCOPES.canView],
    editor: [...SCOPES.canEdit],
    owner: [
        ...SCOPES.canView,
        ...SCOPES.canEdit,
        ...SCOPES.canCreate,
        ...SCOPES.canDelete,
    ],
    'crm-operator': [...SCOPES.canView],
};
